import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Form } from "../../../base/views/useForm";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
// import SelectableSearch from "../../../base/views/SelectableSearch";
// import { GetAllSupplierData } from "../helper/supplierManagementHelper";

const useStyles = makeStyles((theme) => ({
  Appcss: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    borderRadius: "15px",
    padding: "30px",
    justifyContent: "center",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(1, 0, 1),
  },
}));

const initialFValues = {
  supplier_id: 0,
  supplier_name: "",
  aliasname: "",
  address: "",
  contactno: "",
  contactperson: "",
  contactmail: "",
  accountno: "",
  supplierEdiCode: "",
  supplier_type: "",
};

export default function SupplierForm(props) {
  const classes = useStyles();
  const [errors, setErrors] = React.useState({});
  const [addSupplierData, setState] = useState(initialFValues);
  const { addOrEdit, recordForEdit, addSupplier, editSupplier } = props;

  const supplierTypeData = [
    { id: 1, type: "Wholesaler" },
    { id: 2, type: "Reverse Distributor" },
  ];
  // const [supplierNameData, setSupplierNameData] = useState({
  //   load: false,
  //   values: [],
  // });

  // const [allSupplierData, setAllSupplierData] = useState({});

  const validate = (fieldValues = addSupplierData) => {
    let temp = { ...errors };
    if ("supplier_name" in fieldValues) {
      temp.supplier_name =
        fieldValues.supplier_name === "" ? "Supplier Name is required" : "";
    }

    if ("contactmail" in fieldValues)
      temp.contactmail =
        fieldValues.contactmail === ""
          ? "Email is required"
          : /$^|.+@.+..+/.test(fieldValues.contactmail)
          ? ""
          : "Invalid Email.";

    if ("accountno" in fieldValues) {
      temp.accountno =
        fieldValues.accountno === "" ? "Account No. is required" : "";
    }

    if ("aliasname" in fieldValues) {
      temp.aliasname =
        fieldValues.aliasname === ""
          ? "Allias Name is required"
          : //eslint-disable-next-line
          /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(fieldValues.aliasname)
          ? "Allias Name should contain only alphanumeric"
          : "";
    }

    if ("address" in fieldValues) {
      temp.address = fieldValues.address === "" ? "Address is required" : "";
    }

    if ("contactno" in fieldValues) {
      temp.contactno =
        fieldValues.contactno === "" ? "Contact No. is required" : "";
    }

    if ("contactperson" in fieldValues) {
      temp.contactperson =
        fieldValues.contactperson === "" ? "Contact Person is required" : "";
    }
    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...addSupplierData,
      [name]: value,
    });
  };

  // const handleSupplierNameChange = (event, value) => {
  //   if (value) {
  //     const selectedSupplier = allSupplierData.find(
  //       (supplier) => supplier.supplier_name === value.optionname
  //     );
  //     setState({
  //       ...addSupplierData,
  //       contactmail: selectedSupplier.contactmail,
  //       contactno: selectedSupplier.contactno,
  //       address: selectedSupplier.address,
  //       supplierEdiCode: selectedSupplier.suppliercode,
  //       contactperson: selectedSupplier.contactperson,
  //       supplier_name: { id: value.id, optionname: value.optionname },
  //     });
  //   } else {
  //     setState({
  //       ...addSupplierData,
  //       supplierEdiCode: { id: 0, optionname: "" },
  //     });
  //   }
  // };

  // const loadingSupplierNameData = () => {
  //   setSupplierNameData({ ...supplierNameData, load: true });
  //   GetAllSupplierData()
  //     .then((response) => {
  //       setSupplierNameData({
  //         load: false,
  //         values: response.map((obj, index) => ({
  //           id: index,
  //           optionname: obj.supplier_name,
  //         })),
  //       });
  //       setAllSupplierData(response);
  //     })
  //     .catch((err) => {});
  // };

  const HandleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      if (addSupplierData.supplier_id === 0)
        addSupplier({ ...addSupplierData, storeid: props.storeid });
      else editSupplier({ ...addSupplierData, storeid: props.storeid });

      addOrEdit(resetForm);
    }
  };

  const resetForm = () => {
    setState(initialFValues);
    setErrors({});
  };

  useEffect(() => {
    if (recordForEdit != null)
      setState({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  return (
    <Form onSubmit={HandleSubmit}>
      <Container component="main" maxWidth="sm">
        <div className={classes.form}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                required
                value={addSupplierData.supplier_name}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="supplier_name"
                label="Supplier Name"
                name="supplier_name"
                autoComplete="contactmail"
                {...(errors.supplier_name && {
                  error: true,
                  helperText: errors.supplier_name,
                })}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                required
                value={addSupplierData.contactmail}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="contactmail"
                label="Email"
                name="contactmail"
                autoComplete="contactmail"
                {...(errors.contactmail && {
                  error: true,
                  helperText: errors.contactmail,
                })}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                required
                value={addSupplierData.accountno}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="accountno"
                label="Account No."
                name="accountno"
                autoComplete="accountno"
                {...(errors.accountno && {
                  error: true,
                  helperText: errors.accountno,
                })}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                required
                value={addSupplierData.aliasname}
                onChange={handleInputChange}
                variant="outlined"
                disabled={recordForEdit ? true : false}
                fullWidth
                id="aliasname"
                label="Allias Name"
                name="aliasname"
                autoComplete="aliasname"
                helperText={
                  recordForEdit
                    ? ""
                    : "Alias name once created cannot be changed for a supplier"
                }
                {...(errors.aliasname && {
                  error: true,
                  helperText: errors.aliasname,
                })}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                required
                value={addSupplierData.contactno}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="contactno"
                label="Contact No."
                name="contactno"
                autoComplete="contactno"
                type="number"
                {...(errors.contactno && {
                  error: true,
                  helperText: errors.contactno,
                })}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                required
                value={addSupplierData.contactperson}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="contactperson"
                label="Contact Person"
                name="contactperson"
                autoComplete="contactperson"
                {...(errors.contactperson && {
                  error: true,
                  helperText: errors.contactperson,
                })}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl
                style={{ display: "flex", width: "91%" }}
                variant="outlined"
              >
                <InputLabel id="filterlabel">Supplier Type</InputLabel>
                <Select
                  fullWidth
                  labelId="filterlabel"
                  name="supplier_type"
                  id="panselectoutlined"
                  label="supplier type"
                  value={addSupplierData.supplier_type}
                  onChange={handleInputChange}
                >
                  {supplierTypeData.map((option) => (
                    <MenuItem key={option.id} value={option.type}>
                      {option.type}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                id="address"
                value={addSupplierData.address}
                onChange={handleInputChange}
                label="Address"
                multiline
                rows={3}
                variant="outlined"
                fullWidth
                style={{ width: "91%" }}
                name="address"
                autoComplete="address"
                {...(errors.address && {
                  error: true,
                  helperText: errors.address,
                })}
              />
            </Grid>
            <Grid item xs={12}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  style={{
                    width: "20vw",
                    backgroundColor: "rgb(22, 177, 255)",
                    borderRadius: "0.5rem",
                  }}
                  type="button"
                  onClick={HandleSubmit}
                >
                  Save
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </Container>
    </Form>
  );
}
